export default "__VITE_ASSET__4472d94e__"